import React from 'react';
import ReactDOM from 'react-dom/client';
import '@mescius/spread-sheets/styles/gc.spread.sheets.excel2013white.css';
import '@mescius/spread-sheets-designer/styles/gc.spread.sheets.designer.min.css';
import '@mescius/spread-sheets-print';
import '@mescius/spread-sheets-shapes';
import '@mescius/spread-sheets-pivot-addon';
import '@mescius/spread-sheets-tablesheet';
import '@mescius/spread-sheets-resources-ja';
import '@mescius/spread-sheets-designer-resources-ja';
import * as GC from '@mescius/spread-sheets';
import * as ExcelIO from '@mescius/spread-excelio';

import { App } from './pages/App';

import { CustomOidcProvider } from './components/CustomOidcProvider';
import { OpenReLoginDialogProvider } from './services/store/OpenReLoginDialog';

const licenseKey = process.env.REACT_APP_SPREADJS_KEY || '';
const designerLicenseKey = process.env.REACT_APP_SPREADJS_DESIGNER_KEY || '';

GC.Spread.Sheets.LicenseKey = licenseKey;
// @ts-ignore
GC.Spread.Sheets.Designer.LicenseKey = designerLicenseKey;
// 同じライセンスキーを使用して、Excel IOモジュールのライセンスを個別に取得する必要があります。
// @ts-ignore
ExcelIO.LicenseKey = licenseKey;

GC.Spread.Common.CultureManager.culture('ja-jp');

/**
 * 「印刷プレビュー」ボタンを非表示にする
 */
// @ts-ignore
const pageSetupTemplate = GC.Spread.Sheets.Designer.getTemplate(
  // @ts-ignore
  GC.Spread.Sheets.Designer.TemplateNames.PageSetupDialogTemplate
);
// @ts-ignore
pageSetupTemplate.content[0].children.forEach((subTabPage) => {
  subTabPage.children = subTabPage.children.filter(
    // @ts-ignore
    (child) => child.type !== 'PrintButtonGroup'
  );
});
// @ts-ignore
GC.Spread.Sheets.Designer.registerTemplate(
  // @ts-ignore
  GC.Spread.Sheets.Designer.TemplateNames.PageSetupDialogTemplate,
  pageSetupTemplate
);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <OpenReLoginDialogProvider>
      <CustomOidcProvider>
        <App />
      </CustomOidcProvider>
    </OpenReLoginDialogProvider>
  </React.StrictMode>
);
